import React from 'react';

import {BookmakerStripLogo, BookmakerStripLogoProps} from "../bookmaker-strip/bookmaker-strip-logo";
import {PoweredByStrip} from "../misc/powered-by-strip/powered-by-strip";
import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {ModuleController} from "../../../infrastructure/controllers/module-controller";
import {BookmakerViewModel} from "../../../domain/common/bookmaker/models/bookmaker-view-model";
import {AppTerms} from "../../app/app-terms";
import {Disclaimer} from "../desclaimer/disclaimer";
import type {BaseUrlModel} from "../../../infrastructure/models/link/base-url-model";

export class SponsorshipProps extends BaseProps {
  bookmaker: BookmakerViewModel;
  controller: ModuleController;
  i18n: AppTerms;
  poweredByText: String;
  poweredByLink: String;
  onClick: Function;
  clickable: Boolean;
  shouldRenderPoweredBy: Boolean;
  showDisclaimer: Boolean;
  betsImpressionParams: Object;
  bookieHrefModel: BaseUrlModel;
}

export const Sponsorship = ((props: SponsorshipProps) => {
  const poweredByStripProps = {
    className: 'sponsorship-powered-by',
    controller: props.controller,
    title: props.poweredByText,
    link: props.poweredByLink,
    i18n: props.controller.state.terms
  }

  const bookmakerStripLogoProps: BookmakerStripLogoProps = {
    className: 'sponsorship-odds-by',
    bookmaker: props.bookmaker,
    label: props.controller.state.terms.WIDGET_ODDS_BY_DEFAULT,
    logoWidth: 60,
    bookieHrefModel: props.bookieHrefModel,
    clickable: props.clickable && props.onClick,
    onClick: () => props.onClick && props.onClick(),
    controller: props.controller,
    betsImpressionParams: props.betsImpressionParams
  }

  return (
    <div className={['sponsorship-container', props.shouldRenderPoweredBy || props.showDisclaimer ? 'full-sponsorship-container' : ''].join(' ')}>
      {
        props.showDisclaimer ? <Disclaimer /> : null
      }
      {
        props.shouldRenderPoweredBy ? !props.showDisclaimer && <PoweredByStrip {...poweredByStripProps}/> : null
      }
      {
        props.bookmaker ? <BookmakerStripLogo {...bookmakerStripLogoProps}/> : null
      }
    </div>
  )
});
